import { render, staticRenderFns } from "./patientPortalNotify.vue?vue&type=template&id=46caf74c&"
import script from "./patientPortalNotify.vue?vue&type=script&lang=js&"
export * from "./patientPortalNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports